import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";
export interface AssessmentResponse {
  assessment: fhirTypes.DocumentReference | null;
  availableActions: {
    availableActions: {
      action: AssessmentAction;
      unavailableReason: AssessmentUnavailableReason | null;
    }[];
  } | null;
}

export enum AssessmentUnavailableReason {
  GENERATION_ATTEMPTED = "GENERATION_ATTEMPTED",
  IN_SAME_STATUS = "IN_SAME_STATUS",
  IN_VOIDED_STATUS = "IN_VOIDED_STATUS",
  PEDIATRIC_PATIENT = "PEDIATRIC_PATIENT",
  INVALID_ENCOUNTER_ASSIGNMENT = "INVALID_ENCOUNTER_ASSIGNMENT",
  INVALID_USER_ROLE = "INVALID_USER_ROLE",
  INVALID_ENCOUNTER_TYPE = "INVALID_ENCOUNTER_TYPE",
  VISIT_IS_CHAI_ASYNC = "VISIT_IS_CHAI_ASYNC",
}

export enum AssessmentAction {
  GENERATE = "generate",
  VOID = "void",
  UPDATE = "update",
}

export const useAssessment = (encounterId?: string, enabled = true) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApi<AssessmentResponse>({
    queryOptions: {
      enabled: Boolean(encounterId) && enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<AssessmentResponse>(
          `/charting/encounter-charting/${encounterId}/assessment`,
        );
        return response.data;
      },

      queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.Assessment.DEFAULT({
        patientId,
        encounterId: encounterId,
      }),
    },
  });
};
